import { render, staticRenderFns } from "./wikiIntro.vue?vue&type=template&id=37a28acb&scoped=true"
import script from "./wikiIntro.vue?vue&type=script&lang=js"
export * from "./wikiIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a28acb",
  null
  
)

export default component.exports